// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { SendanorProductId } from "../types/SendanorProductId";
import { ProductPriceType } from "../../../../io/hyperify/core/store/types/product/ProductPriceType";

export const CURRENT_YEAR = new Date().getFullYear();
export const COMPANY_BUSINESS_ID = "2092540-6";
export const COMPANY_VAT_ID = "FI20925406";
export const COMPANY_PHONE_NUMBER_DISPLAY = "040 7300 149";
export const COMPANY_PHONE_NUMBER_FULL = "+358407300149";
export const PRIVACY_HANDLER_NAME = 'Jaakko Heusala';
export const PRIVACY_HANDLER_EMAIL = 'jhh@sendanor.com';
export const PRIVACY_HANDLER_PHONE_DISPLAY = '040 7300 149';
export const PRIVACY_HANDLER_PHONE_FULL = '+358407099704';
export const COMPANY_EMAIL = 'info@sendanor.fi';
export const MAINTENANCE_PHONE_NUMBER_DISPLAY = "040 7300 149";
export const MAINTENANCE_PHONE_NUMBER_FULL = "+358407099704";
export const COMPANY_NAME = "Sendanor";
export const COMPANY_ADDRESS_LINE_1 = "Keskustori 7 A 14";
export const COMPANY_ADDRESS_LINE_2 = "33100 Tampere";
export const DESIGN_COMPANY_NAME = "Avinse Graphics";
export const DESIGN_COMPANY_WEBSITE = "https://avinse.fi";
export const IMPLEMENTATION_COMPANY_NAME = "Heusala Group Oy";
export const IMPLEMENTATION_COMPANY_WEBSITE = "https://heusalagroup.fi";
export const SENDANOR_SHELL_WEBSITE = 'https://shell.sendanor.fi/';
export const SENDANOR_SOFTWARE_WEBSITE = 'https://github.com/hyperifyio/project-govm';
export const SENDANOR_VPS_WEBSITE = 'https://vps.nor.fi/';
export const SENDANOR_PROJECT_WEBSITE = 'https://github.com/sendanor/project-sendanor.fi';
export const SENDANOR_PROJECT_TRACKER_WEBSITE = 'https://github.com/sendanor/project-sendanor.fi/issues/1';
export const SENDANOR_NOTIFICATIONS_WEBSITE = 'https://tiedotteet.sendanor.fi/';
export const SENDANOR_MAIL_WEBSITE = 'https://mail.nor.fi/';
export const COMPANY_TWITTER_NAME = 'sendanorfi';
export const COMPANY_TWITTER_URL = `https://twitter.com/${COMPANY_TWITTER_NAME}`;
export const COMPANY_FACEBOOK_URL = 'https://www.facebook.com/sendanor/';
export const COMPANY_GITHUB_URL = 'https://github.com/sendanor';
export const COMPANY_LINKEDIN_URL = 'https://www.linkedin.com/company/sendanor';
export const COMPANY_DISCORD_URL = 'https://discord.gg/dVTpkTh';
export const SENDANOR_PREMIUM_DOMAIN_WEBSITE = 'https://holvi.com/shop/sendanor/section/verkkotunnukset/';
export const SENDANOR_PHOTO_WEBSITE = 'https://holvi.com/shop/sendanor/section/kuvat/';
export const SENDANOR_WEBRTC_WEBSITE = 'https://www.2q.fi/';

export const META_PIXEL_PRIVACY_CONTENT_URL = 'https://www.facebook.com/privacy/policy/';

export const SENDANOR_BOOKING_URL = 'https://outlook.office365.com/owa/calendar/Sendanor@sendanor.org/bookings/';

export const COMPANY_FOUNDING_YEAR = 2007;
export const COMPANY_ACTIVE_YEARS = new Date().getFullYear() - COMPANY_FOUNDING_YEAR;

// export const SENDANOR_HOLVI_WEBSITE = 'https://holvi.com/shop/sendanor/';
// export const SHELL_HOLVI_URL = 'https://holvi.com/shop/sendanor/product/e2007478b5ed461ce896923119c0ab2f/';

// export const VIRTUALSERVERS_PRODUCT_1_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/3a20c552d063aa0c3481a8a62f3f2624/';
// export const VIRTUALSERVERS_PRODUCT_2_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/d4fd9b45fa6ecc2823e8bc88fbf0b88b/';
// export const VIRTUALSERVERS_PRODUCT_3_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/4d2b7293ae5a9cf9f8d7552eb42a3669/';
// export const VIRTUALSERVERS_PRODUCT_4_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/ee0e1b6195b216f9dd9e67cdc5b16cd2/';
// export const WEBHOTELS_PRODUCT_1_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/8149584c70cecdc80c4f3b852e075f9e/';
// export const WEBHOTELS_PRODUCT_2_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/19baa1b0db529ef3ed7515d37e01a19c/';
// export const EMAIL_PRODUCT_1_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/c8912d7078369b86e392d7d6f5b3e743/';
// export const EMAIL_PRODUCT_2_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/f29d198fb6ff8431288f30121e92c886/';
// export const SHELL_PRODUCT_1_BUY_URL_YEARS_10 = 'https://holvi.com/shop/sendanor/product/e2007478b5ed461ce896923119c0ab2f/';

// export const VIRTUALSERVERS_PRODUCT_1_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/c6f72263babe2a4d521254ba7a36104e/';
// export const VIRTUALSERVERS_PRODUCT_2_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/289401519fb8bb0cb271e9a36cad1963/';
// export const VIRTUALSERVERS_PRODUCT_3_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/90ed8ae0bbb021031e3dbf16b91c1eb7/';
// export const VIRTUALSERVERS_PRODUCT_4_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/c64f9ce3711716479e62ffcfd6167e3d/';
// export const WEBHOTELS_PRODUCT_1_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/a0dd7f3c3b3a4a140813d3381a282d4b/';
// export const WEBHOTELS_PRODUCT_2_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/8e7134cca7e6cb68e276efec5baa44b6/';
// export const EMAIL_PRODUCT_1_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/c846abf43a504f985b40bf5e704c2c8b/';
// export const EMAIL_PRODUCT_2_BUY_URL_YEARS_3 = 'https://holvi.com/shop/sendanor/product/44df8783fa0113c21ab411c0d7ff2d8f/';

export const PRODUCT_BUY_URL_PREFIX = (id: SendanorProductId, price: ProductPriceType) => `https://www.sendanor.fi/product/${id}/${price}`;

export const SOFTWARE_ENABLED = false;
export const DOMAINS_ENABLED = false;
export const PAYTRAIL_ENABLED = false;
